import gql from 'graphql-tag';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';
import { UserAllDataFragment } from '../fragments';

export default gql`
query adminUser($filters: UserFilters, $sortBy: UserSort, $count: Int!, $page: Int) {
    listAdmins(filters: $filters, sortBy: $sortBy, first: $count, page: $page) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...UserAllDataFragment
        }
    }
}
${PaginatorInfoFragment}
${UserAllDataFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminUser.ts